// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"PlayVimeo_modalWrapper_1IOT4","videoContainer":"PlayVimeo_videoContainer_2LwgO"};